// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"90eafb88","276":"17b07892","642":"7569b801","765":"9e7aad51","989":"9a10be93","999":"92ed6af9"}[chunkId] + ".chunk.css";
};